<template>
  <tr>
    <td
      class="boss-table-data pega-break"
    >
      <span data-test="file-name">{{ summaryFile.name }}</span>
      <span data-test="file-size">{{ summaryFile.size | formatSize }}</span>
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-sent"
    >
      {{ summaryFile.sentDate | formatDateTime }}
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-period"
    >
      {{ summaryFile.expiredDate | formatDate }}
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-download"
    >
      <template v-if="!summaryFile.manualDeletedDate && !isExpired">
        <button
          class="boss-button"
          data-test="button-download"
          @click="download(summaryFile.id, summaryFile.name)"
        >
          <span>ダウンロード</span>
        </button>
        <button
          v-if="canSendMessage"
          class="delete-button"
          data-test="button-delete"
          @click="doRemove(summaryFile.id)"
        >
          <span>削除</span>
        </button>
      </template>
      <span
        v-else
        data-test="delete-file"
      >
        {{ summaryFile.manualDeletedDate ? `${summaryFile.deletedCompanyStaff}によって${$options.filters.formatDate(summaryFile.manualDeletedDate)}に削除済み` : '閲覧期限終了' }}
      </span>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'
import { formatBytes } from '@/lib/formatBytes'
import { downloadFile } from '@/lib/download'
import { mapGetters } from 'vuex'

export default {
  filters: {
    formatSize (size) {
      return size ? `(${formatBytes(size)})` : ''
    },
    formatDateTime (date) {
      return date ? dayjs(date).format('YYYY/MM/DD(ddd) HH:mm') : ''
    },
    formatDate (date) {
      return date ? dayjs(date).format('YYYY-MM-DD') : ''
    }
  },
  props: {
    summaryFile: {
      type: Object,
      default: () => {}
    },
    entryId: {
      type: Number,
      required: true
    }
  },
  computed: {
    messageId () {
      return this.summaryFile.messageId
    },
    isExpired () {
      return dayjs().isAfter(dayjs(this.summaryFile.expiredDate), 'days')
    },
    ...mapGetters([
      'canSendMessage'
    ])
  },
  methods: {
    removeFile (fileId) {
      this.$http.secured.put(`/entry/message/send/file_upload/entries/${this.entryId}/messages/${this.messageId}/files/${fileId}/_closed`).then(() => {
        this.$toasted.global.success({ message: 'ファイルを削除しました。' })
        this.$emit('fetchAllMessage')
      })
    },
    download (fileId, fileName) {
      downloadFile(`/entry/view/entries/${this.entryId}/messages/${this.messageId}/files/${fileId}/download`, fileName)
    },
    doRemove (fileId) {
      this.$dialog.confirm('応募者のマイページからも削除されますがよろしいですか？')
        // はいを押下した時
        .then(() => {
          // 削除処理追加
          this.removeFile(fileId)
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
